<template>
  <div class="bjzx-detail-container">
    <div class="noStuClass" v-if="isNoStu">
      <img src="@/assets/img/qietu/noStu.png" alt="">
      <p>未找到该学者</p>
    </div>
    <div v-else>
      <SubHeader :activeId="activeId" :subList="navList" :personalObject="personal" @changeNav="changeNav" />
      <div class="bjzx-content">
        <div class="content">
          <components :is="isShow"></components>
          <!-- <router-view></router-view> -->
        </div>
        <div class="bjzx-side">
          <BestArticle
            class="blog-container"
            title="近期最佳文章"
            :contentList="blogList"
          ></BestArticle>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "@/components/pager/SubHeader.vue";
import BestArticle from "@/components/pager/BestArticle.vue";
// import BjVideo from "./view/BjVideo.vue";
import Blog from "./view/Blog.vue";
import Wenxian from "./view/Wenxian.vue";
import Main from "./view/Main.vue";
import BjMonograph from "./view/BjMonograph.vue";
import Course from "./view/Course.vue";
export default {
  components: {
    SubHeader,
    BestArticle
  },
  data() {
    return {
      isShow: Main,
      isNoStu: false,
      activeId: 0,
      navList: [
        {
          title: "主页",
          id: 0,
          name: Main,
        },
        {
          title: "资讯",
          id: 1,
          name: Blog,
        },
        // {
        //   title: "视频",
        //   id: 2,
        //   name: 'BjVideo',
        // },
        {
          title: "论文",
          id: 3,
          name: Wenxian,
        },
        {
          title: "专著",
          id: 4,
          name: BjMonograph,
        },
        {
          title: "课程",
          id: 5,
          name: Course,
        },
      ],
      personal: {},
      blogList: [],
    };
  },
  created() {
    this.getReadRankingList({
      id: this.$route.query.id,
      pageNo: 1,
      pageSize: 5,
      userType: 0,
    }); //近期最佳文章
    this.bjDetailList({
      userId: this.$route.query.id,
    });
  },
  methods: {
    changeNav(name,id) {
      this.activeId = id
      this.isShow = name
    },
    async getReadRankingList(data) {
      const resp = await this.$apis.hundredServe.getReadRankingList(data);
      this.blogList = resp.data.list;
    },
    async bjDetailList(data) {
      const resp = await this.$apis.hundredServe.bjDetailList(data);
      document.title = resp.content.detail.userInfo.realname + ' - 中文知识网'
      if (resp.resultCode === '1008') {
        this.isNoStu = true
      } else if (resp.content.detail) {
        this.personal = resp.content.detail;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noStuClass {
  padding-top: 200px;
  width: 100%;
  height: 729px;
  background-color: #fff;
  border: 1px solid #A3CBE7;
  border-radius: 10px;
  text-align: center;
  img {
    width: 279px;
    height: 234px;
  }
  p {
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.bjzx-content {
  display: flex;
  margin-top: 255px;
  .content {
    width: 886px;
    background-color: #fff;
    margin-bottom: 16px;
    margin-right: 30px;
    min-height: 500px;
  }
}
.bjzx-side {
  width: 295px;
  .blog-container {
    background-color: #fff;
  }
}
.footer {
  margin-top: 30px;
  text-align: center;
  color: #ccc;
}
</style>
